class ConfigService {
	/**
	 * class constructor method
	 */
	constructor() {
		/**
		 * Application version
		 * @type {number}
		 */
		this.version = 1.0;
		/**
		 * SB Rest url
		 * @type {string}
		 */
		this.baseUrl = APP_SETTINGS.path.apiUrl;

		// Mobile only endpoints
		const mobileEndpoints = ({
			languageResource: 'rest/FEMobile/GetLanguageResources',
			fixtureMenu: 'rest/FEMobile/GetFixturesMenu',
			sportsMenu: 'rest/FEMobile/GetFixturesSports',
			homeMatches: 'rest/FEMobile/GetPagedMatches',
			categoryOutrights: 'rest/FEMobile/GetCategoryOutrights',
			search: 'rest/FEMobile/SearchEventsByName',
			myfavorites: 'rest/FEMobile/GetFavouriteMatches',
			getMobileManifest: 'rest/FEWPlayer/LCGetMobileStream',
			settings: 'rest/FEMobile/GetAllSettings',
			matchOdds: 'rest/FEMobile/GetMatchOdds',
			scorecast: 'rest/FEMobile/GetMatchOddsScorecast',
			betSlipOffer: 'rest/Betslip/BetSlipOffer',
			liveChannelOnline: 'rest/FEWHome/LCStreamedMatches',
			getAllSports: 'rest/FEMobile/GetSports',
			betSlipCashout: 'rest/Betslip/BetSlipCashoutAsync',
			getUserProfile: 'rest/FEMobile/GetUserProfile',
			bonuses: 'rest/FEMobile/GetUserBonuses',
			wageredBonus: 'rest/FEMobile/SetUserWageredBonus',
			liveUpcomingFixture: 'rest/FEMobile/LiveUpcomingFixture',
			couponsList: 'rest/FECoupon/List',
			couponDetails: 'rest/FECoupon/Details',

			// TODO:SHARED different names
			// Rename them in original requests and then delete them from here
			categoryMatches: 'rest/FEMobile/GetGroupedMatches',
			horseRacingOutrights: 'rest/FEWFixture/GetNextRaces',
			horseRacingCategories: 'rest/FEWFixture/GetHRCategoriesMenu',
			tournamentOutrightsHorseRacing: 'rest/FEWFixture/TournamentOutrightsHorseRacing',
			horseRacingOutrightRace: 'rest/FEWFixture/GetOutrightRace',
			hrTimeFilter: 'rest/FEWFixture/GetTodaysRacesHorseData',
			newMybets: 'rest/FEWBetSlip/History',
			mybetsDetailsFront: 'rest/FEWBetSlip/HistoryDetails',
			matchTabs: 'rest/FEMobile/GetMatchTabs',
			liveStreaming: 'rest/FEWHome/LCGetStreamedMatches',
			liveStreamingList: 'rest/FEWHome/LCGetShortStreamedMatches',
			mainMarkets: 'rest/FEWHome/MainWidgetMarkets',
			marketMatchOdds: 'rest/FEWHome/MatchOddsForMarket',
		});

		// Web only endpoints
		const webEndpoints = ({
			layoutSource: 'rest/FELayout/GetLayoutSettings',
			allLayouts: 'rest/FELayout/LayoutSettings',
			languageResource: process.env.VUE_APP_IS_AGENT ? 'rest/FEAHome/LanguageResources' : 'rest/FEWHome/LanguageResources',
			fixtureMenu: 'rest/FEWFixture/FixturesMenu',
			sportsMenu: 'rest/FEWFixture/FixtureSports',
			getUpcoming: 'rest/FEWHome/Upcoming',
			getHighlights: 'rest/FEWHome/Highlights',
			liveMatches: 'rest/FEWHome/GetLiveMatchesMetaData',
			liveMatchesMobile: 'rest/FEMobile/GetLiveMatchesMetaData',
			categoryMatches: 'rest/FEWFixture/GroupedMatches',
			categoryMatchesList: 'rest/FEMobile/GetGroupedMatches',
			categoryOutrights: 'rest/FEWFixture/CategoryOutrights',
			tournamentOutrights: 'rest/FEWFixture/TournamentOutrights',
			horseRacingOutrights: 'rest/FEWFixture/TournamentOutrightsHorseRacing',
			horseRacingSportOutrights: 'rest/FEWFixture/GetNextRaces',
			hrCategoryMenu: 'rest/FEWFixture/GetHRCategoriesMenu',
			hrTimeFilter: 'rest/FEWFixture/GetTodaysRacesHorseData',
			hrRaceOddDetails: 'rest/FEWFixture/GetOutrightRace',
			search: 'rest/FEWHome/SearchEventsByName',
			mybets: 'rest/FEWBetSlip/History',
			checkCashout: 'rest/FEWBetSlip/CheckCashout',
			mybetsDetails: 'rest/FEWBetSlip/HistoryDetails',
			winningsDetails: 'rest/FEWHome/WinningsDetails',
			myfavorites: 'rest/FEWHome/GetFavouriteMatches',
			getWebManifest: 'rest/FEWPlayer/LCGetDesktopStream',
			placebet: 'rest/FEWBetslip/Place', // FEWBetslip/Place no userid required
			incompatibility: 'rest/Betslip/CheckItemForIncompatibility',
			getUserFreebets: 'rest/FEWFreeBet/UserFreeBets', // FEWFreeBet/UserFreeBets [GET]
			settings: 'rest/FEWHome/AllSettings',
			checkBetslipAgent: 'rest/FEABetSlip/CheckBetslip',
			matchMetadata: 'rest/FEMobile/GetMatchTabs',//'rest/FEWMatches/MatchTabsFirst',
			matchOdds: 'rest/FEWMatches/MatchOdds',
			scorecast: 'rest/FEWMatches/MatchOddsScorecast',
			betSlipOffer: 'rest/FEWBetslip/BetslipOffer', // FEWBetslip/BetslipOffer
			getAllSports: 'rest/FEWFixture/Sports',
			affiliateUsersHist: 'rest/FEWBetslip/GetAffiliateUsersHist', // no userid in params
			// sb-front specific endpoints:
			virtualTennisFixtures: 'rest/Fixtures/GetFixturesVTOMatches',
			topWinnings: 'rest/FEWHome/TopWinnings',
			matchCode: 'rest/FEWHome/MatchByEventID',
			matchOddsForMarket: 'rest/FEWHome/MatchOddsForMarket',
			sportTabs: 'rest/FEWFixture/SportTabs',
			tournamentOdds: 'rest/FEWFixture/TournamentMatchOdds',
			bonuses: 'rest/FEWBetslip/GetUserBonuses', // no parameters
			wageredBonus: 'rest/FEWBetslip/SetUserWageredBonus', // no userid in params
			printOdds: 'rest/FEWFixture/CategoryPrint',
			sportsCombo: 'rest/FEWHome/MainWidgetMarkets',
			printFixtureLogo: 'rest/FEWFixture/PrintFixtureLogo',
			liveChannelOnline: 'rest/FEWHome/LCGetStreamedMatches',
			liveStreamingAll: 'rest/FEWHome/LCGetShortStreamedMatches',
			upcomingFixture: 'rest/FEWFixture/UpcomingFixture',
			betSlipCashout: 'rest/FEWBetslip/Cashout', // FEWBetslip/Cashout  - no userid in params
			onlineShop: 'rest/OnlineShop/SetPermissions',
			setPermissions: 'rest/OnlineShop/SetPermissions',
			getAffiliateUsers: 'rest/FEWBetslip/GetAffiliateUsers', // no params
			seenNotify: 'rest/FEWNotification/Seen', // FEWNotification/Seen
			// setPermissions: '/onlineshop/SetPermissions',
			cancelPlacedBetslip: 'rest/FEABetSlip/CancelGroup',
			searchUser: 'rest/FEABetSlip/SearchUser',
			outrightsDetails: 'rest/FEWFixture/OutrightDetails',
			sportOutrights: 'rest/FEWFixture/SportOutrights',
			paidBetslip: 'rest/FEABetSlip/Paid',
		});

		// Shared endpoints
		const sharedEndpoints = ({
			categoryMatches: 'rest/FEMobile/GetGroupedMatches',
			horseRacingOutrights: 'rest/FEWFixture/GetNextRaces',
			horseRacingCategories: 'rest/FEWFixture/GetHRCategoriesMenu',
			tournamentOutrightsHorseRacing: 'rest/FEWFixture/TournamentOutrightsHorseRacing',
			horseRacingOutrightRace: 'rest/FEWFixture/GetOutrightRace',
			hrTimeFilter: 'rest/FEWFixture/GetTodaysRacesHorseData',
			newMybets: 'rest/FEWBetSlip/History',
			betBuilderHistoryDetails: 'rest/FEWBetSlip/HistoryBBDetails',
			// TODO: remove after refactor
			mybetsDetailsFront: 'rest/FEWBetSlip/HistoryDetails',
			mybetsDetails: 'rest/FEWBetSlip/HistoryDetails',
			placebet: 'rest/FEWBetslip/Place',
			game: 'rest/FEMobile/GetMatchDetailOdds',
			playerOdds: 'rest/FEMobile/GetMatchPlayerOdds',
			playerMarkets: 'rest/FEWMatches/MatchPlayersOdd',
			settings: 'rest/FEMobile/GetAllSettings',
			calculateBonus: 'rest/FEWBetslip/CalculateBonus',
			checkBetslip: 'rest/FEWHome/CheckBetslip',
			getActiveSpecialBetTypeCombinations: '/rest/FEWHome/GetActiveSpecialBetTypeCombinations',
			BookBetslip: 'rest/ReserveBetSlip/Reserve',
			LoadBetslip: 'rest/ReserveBetSlip/Retrieve',
			matchTabs: 'rest/FEMobile/GetMatchTabs',
			liveStreaming: 'rest/FEWHome/LCGetStreamedMatches',
			liveStreamingList: 'rest/FEWHome/LCGetShortStreamedMatches',
			playerInfo: 'rest/FEWPlayer/PlayerInfo',
			mainMarkets: 'rest/FEWHome/MainWidgetMarkets',
			marketMatchOdds: 'rest/FEWHome/MatchOddsForMarket',
			printTicketLogo: 'rest/FEWFixture/PrintTicketLogo',
			getBonusBrands: 'rest/FEWBetslip/GetBonusBrands',
			getBonusRules: 'rest/FEWBetslip/GetAccumulatorBonusRules',
			getUserFreebets: 'rest/FEWFreeBet/UserFreeBets',
			getLimitsByCurrencies: 'rest/FEWLimits/GetLimitsByCurrencies',
			boostedOdds: 'rest/BoostedOdd/GetBoostedOdds',
			swish: 'rest/FEMobile/GetSFMatchDetails',
			swishBetRequest: '/rest/FEMobile/SwishABetRequest',
			topEvents: 'rest/FEWTopEvents/GetTopEvents',
			getLiveMatchTabs: 'rest/FEWHome/GetLiveMatchTabs',
			quickLinks: 'rest/FEWQuickLinks/GetQuickLinks',
			highlightedTournaments: 'rest/FEWHome/GetAllHighlightedTournamentsWithSports',
			getForeTricastOdds: 'rest/FEWHome/GetForecastTricastOdds',
			combinedSlider: 'rest/CombinedSlider/GetCombinedSliderElements',
			simulateOddTypesIdentifiers: 'rest/FEWSimulate/GetOddTypesIdentifiers',
        	algoOdd: '/rest/FEWAlgoBet/GetAlgoPrice',
			algoHistoryDetails: 'rest/FEWBetSlip/HistoryABBDetails',
			boostedOddsHistoryDetails: 'rest/FEWBetSlip/HistoryBODetails',

		});
		const endpoints = process.env.VUE_APP_IS_MOBILE ? mobileEndpoints : webEndpoints;
		/**
		 * All available endpoints
		 * @type {typeof sharedEndpoints & typeof webEndpoints & typeof mobileEndpoints}
		 */
		this.endpoints = {
			...sharedEndpoints,
			...endpoints
		};
		/**
		 * All mock data can be set here
		 */
		this.widgetData = {};
		/**
		 * custom headers
		 */
		this.customHeaders = {
			connectionId: '',
		};
		/**
		 * default headers used on lot of requests
		 */
		this.defaultHeaders = {
			Culture: APP_SETTINGS.player.language,
		};
		/**
		 * custom headers
		 */
		this.authorizationHeaders = {
			Provider: APP_SETTINGS.settings.userProviderId || 0,
			Token: APP_SETTINGS.player.token,
		};
	}
}

/**
 * We are exporting the config service here so we can use single instance try all app
 */
export default new ConfigService();
